import { Flex, Tag } from 'antd'
import { Invoice } from 'types'
import { INVOICE_STATUS_COLORS } from '../InvoicesList/constants'

const getStatusTags = (invoice: Invoice): { color: string; label: string }[] => {
  const tags: { color: string; label: string }[] = [
    invoice.finalized
      ? { color: INVOICE_STATUS_COLORS.FINALIZED, label: 'Finalized' }
      : { color: INVOICE_STATUS_COLORS.DRAFT, label: 'Draft' },
  ]
  if (invoice.finalized) {
    tags.push(
      invoice.paid
        ? { color: INVOICE_STATUS_COLORS.PAID, label: 'Paid' }
        : { color: INVOICE_STATUS_COLORS.UNPAID, label: 'Unpaid' }
    )
  }
  return tags
}

interface InvoiceStatusTagsProps {
  invoice: Invoice
  gap?: number | string
  className?: string
}

const InvoiceStatusTags = ({ invoice, gap = 4, className }: InvoiceStatusTagsProps) => (
  <Flex gap={gap} wrap className={className}>
    {getStatusTags(invoice).map(({ color, label }) => (
      <Tag key={label} color={color}>{label}</Tag>
    ))}
  </Flex>
)

export default InvoiceStatusTags
